<template>
  <div>
    <el-select v-model="year" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <div class="countList">
      <div
        v-for="(item, index) in countList"
        :key="index"
        class="countList-item"
      >
        <div class="value">{{ item.value }}</div>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
    <div class="wrapper">
      <div class="wrapper-box">
        <div class="table-wrapper">
          <div class="table-header">
            <div
              class="header"
              v-for="(item, index) in headerNameList"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
          <vue-seamless-scroll
            :data="tableList"
            :class-option="classOption"
            class="table-body"
          >
            <div class="table-list">
              <div class="line" v-for="(item, index) in tableList" :key="index">
                <div class="line-item1">
                  <div class="round">{{ index + 1 }}</div>
                </div>
                <div class="line-item2">{{ item.orderNum }}</div>
                <div class="line-item3">{{ item.orderAmount }}</div>
                <div class="line-item3">{{ item.goodsName }}</div>
                <div class="line-item3">{{ item.data }}</div>
              </div>
            </div>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LsAuditorium',
  data() {
    return {
      options: [
        {
          value: '2022年',
          label: '2022年'
        },
        {
          value: '2021年',
          label: '2021年'
        },
        {
          value: '2020年',
          label: '2020年'
        },
        {
          value: '2019年',
          label: '2019年'
        }
      ],
      year: '2022年',
      countList: [
        {
          name: '申领总金额(元）',
          value: '500万'
        },
        {
          name: '订单总金额(元）',
          value: '334万'
        },
        {
          name: '申领企业数（家）',
          value: '299'
        },
        {
          name: '服务劵兑付总金额（元）',
          value: '293.9万'
        }
      ],
      headerNameList: [
        {
          name: '序号'
        },
        {
          name: '订单号'
        },
        {
          name: '订单金额'
        },
        {
          name: '商品名称'
        },
        {
          name: '创建时间'
        }
      ],
      tableList: [
        {
          orderNum: 'ls202105211',
          orderAmount: '10000',
          goodsName: '收税筹划咨询',
          data: '2021-01-01'
        },
        {
          orderNum: 'ls202105211',
          orderAmount: '10000',
          goodsName: '收税筹划咨询',
          data: '2021-01-01'
        },
        {
          orderNum: 'ls202105211',
          orderAmount: '10000',
          goodsName: '收税筹划咨询',
          data: '2021-01-01'
        },
        {
          orderNum: 'ls202105211',
          orderAmount: '10000',
          goodsName: '收税筹划咨询',
          data: '2021-01-01'
        },
        {
          orderNum: 'ls202105211',
          orderAmount: '10000',
          goodsName: '收税筹划咨询',
          data: '2021-01-01'
        }
      ],
      pageNum: 1,
      pageSize: 5,
      totalRecord: 5
    }
  },
  computed: {
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 8, // 开始无缝滚动的数据量  //this.fourDatata.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  methods: {
    handleCurrentChange() {},
    handleSizeChange() {}
  }
}
</script>

<style lang="scss" scoped>
@import './style/common.scss';
.countList {
  width: 100%;
  display: flex;
  color: #fff;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
  &-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 24.5%;
    margin-right: 0.16rem;
    height: 0.7rem;
    padding-left: 0.4rem;
    border-radius: 0.02rem;
    box-shadow: inset 0 0 0.2rem 0 rgba(18, 254, 253, 0.57);
    .name {
      font-size: 0.14rem;
    }
    .value {
      font-size: 0.2rem;
    }
  }
}
.wrapper {
  display: flex;
  width: 100%;
  height: calc(100% - 2rem);
  &-box {
    width: 100%;
    height: 100%;
    .right-title {
      color: rgba(255, 255, 255, 100);
      font-size: 0.18rem;
    }
    .table-wrapper {
      width: 100%;
    }
    .table-header {
      width: 100%;
      display: flex;
      .header {
        flex: 1;
        height: 0.4rem;
        line-height: 0.4rem;
        text-align: center;
        background-color: rgba(0, 164, 221, 0.21);
        color: rgba(255, 255, 255, 65);
      }
    }
    .table-body {
      width: 100%;
      height: 3.5rem;
      overflow: hidden;
      box-sizing: border-box;
      .table-list {
        padding: 0;
        margin: 0;
        width: 100%;
      }
      .line {
        display: flex;
        justify-content: space-around;
        width: 100%;
        .line-item1 {
          flex: 1;
          text-align: center;
          height: 0.4rem;
          line-height: 0.4rem;
          text-align: center;
          .round {
            margin: 0 auto;
            margin-top: 0.05rem;
            width: 0.3rem;
            height: 0.3rem;
            line-height: 0.3rem;
            border-radius: 50%;
            color: #fff;
            font-size: 0.16rem;
            box-shadow: inset 0px 0px 8px 0px rgba(18, 254, 253, 1);
          }
        }
        .line-item2 {
          text-align: center;
          flex: 1;
          height: 0.4rem;
          line-height: 0.4rem;
          color: #fff;
          font-size: 0.14rem;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .line-item3 {
          flex: 1;
          line-height: 0.4rem;
          text-align: center;
          height: 0.4rem;
          color: #fff;
          font-size: 0.14rem;
        }
      }
      .line:nth-child(even) {
        background-color: rgba(0, 18, 34, 0.4);
      }
    }
  }
}
</style>
